import React from "react";
import Moment from "react-moment";

const styles = {
  root: {
    maxWidth: "595px",
    fontFamily: "roboto",
  },

  titleWrapper: {
    display: "block",
    fontSize: "0px",
    margin: "0 0 32px",
    padding: "0",
  },
  title: {
    display: "block",
    fontSize: "48px",
    lineHeight: "48px",
    fontWeight: "bold",
    fontStyle: "italic",
    margin: "0",
    padding: "0",
    fontFamily: "roboto",
  },
  slogan: {
    display: "block",
    fontSize: "16px",
    lineHeight: "32px",
  },
  type: {
    display: "block",
    textTransform: "uppercase",
    fontSize: "24px",
    fontWeight: 900,
    textAlign: "right",
    margin: "0",
    padding: "0",
  },
  p: {
    margin: 0,
    lineHeight: "24px",
  },
  table: {
    border: "2px solid #eee",
    borderBottom: "none",
    borderRight: "none",
    padding: "0",
    margin: "0",
    borderSpacing: "0px",
    borderCollapse: "separate",
  },
  thead: {},
  tbody: {},
  tfoot: {},
  tr: {},
  th: {
    lineHeight: "48px",
    padding: "0 16px",
    borderBottom: "2px solid #eee",
    borderRight: "2px solid #eee",
  },
  td: {
    lineHeight: "24px",
    padding: "6px 16px",
    borderBottom: "2px solid #eee",
    borderRight: "2px solid #eee",
  },
  addresses: {
    width: "100%",
    margin: "0 0 32px",
    textAlign: "left",
  },
  addressFrom: {
    textAlign: "right",
  },
  addressTo: {},
  details: {
    width: "100%",
    margin: "0 0 32px",
    textAlign: "left",
  },
  detailCell: {
    width: "33.33333333%",
    textAlign: "center",
  },
  rows: {
    width: "100%",
    margin: "0 0 32px",
    textAlign: "left",
  },

  quantity: {
    width: "10%",
    textAlign: "left",
  },
  sku: {
    width: "15%",
    textAlign: "left",
  },
  description: {
    width: "45%",
    textAlign: "left",
  },
  amount: {
    width: "15%",
    textAlign: "right",
  },
  subtotal: {
    width: "15%",
    textAlign: "right",
  },
  total: {
    lineHeight: "64px",
    textAlign: "right",
  },
};

export default class extends React.Component {
  render() {
    const { id, date, reference, title, addressTo, addressFrom, items, total } =
      this.props.document;

    console.log("items", items);
    const hasHeader = this.props.hasHeader ?? true;

    return (
      <div className="document-wrapper">
        <div className="document" style={styles.root}>
          {hasHeader ? (
            <table cellpadding="0" style={styles.addresses}>
              <tbody>
                <tr>
                  <td style={styles.addressTo}>
                    <p style={styles.titleWrapper}>
                      <p style={styles.title}>NegAir</p>
                    </p>
                  </td>
                  <td style={styles.addressFrom}>
                    <p style={styles.titleWrapper}>
                      <p style={styles.type}>{title}</p>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td style={styles.addressTo}>
                    {addressTo.map((line) => (
                      <p style={styles.p}>{line}</p>
                    ))}
                  </td>
                  <td style={styles.addressFrom}>
                    {addressFrom.map((line) => (
                      <p style={styles.p}>{line}</p>
                    ))}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : null}

          <table cellpadding="0" style={{ ...styles.table, ...styles.details }}>
            <thead style={{ ...styles.thead }}>
              <tr style={{ ...styles.tr }}>
                <th
                  style={{
                    ...styles.th,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    ...styles.th,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  Purchase Number
                </th>
                <th
                  style={{
                    ...styles.th,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  Your Reference
                </th>
              </tr>
            </thead>
            <tbody style={{ ...styles.tbody }}>
              <tr style={{ ...styles.tr }}>
                <td
                  style={{
                    ...styles.td,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  <Moment unix format="DD/MM/YY">
                    {date}
                  </Moment>
                </td>
                <td
                  style={{
                    ...styles.td,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  {id}
                </td>
                <td
                  style={{
                    ...styles.td,
                    ...styles.textCenter,
                    ...styles.detailCell,
                  }}
                >
                  {reference}
                </td>
              </tr>
            </tbody>
          </table>

          <table cellpadding="0" style={{ ...styles.table, ...styles.rows }}>
            <thead style={{ ...styles.thead }}>
              <tr style={{ ...styles.tr }}>
                <th style={{ ...styles.th, ...styles.quantity }}>Qty</th>
                <th style={{ ...styles.th, ...styles.sku }}>SKU</th>
                <th style={{ ...styles.th, ...styles.description }}>
                  Description
                </th>
                <th style={{ ...styles.th, ...styles.amount }}>Amount</th>
                <th style={{ ...styles.th, ...styles.subtotal }}>Subtotal</th>
              </tr>
            </thead>
            <tbody style={{ ...styles.tbody }}>
              {items.map((item) => (
                <tr style={{ ...styles.tr }}>
                  <td style={{ ...styles.td, ...styles.quantity }}>
                    {item.quantity}
                  </td>
                  <td style={{ ...styles.td, ...styles.sku }}>
                    {item.partnumber}
                  </td>
                  <td style={{ ...styles.td, ...styles.description }}>
                    {item.description}
                  </td>
                  <td style={{ ...styles.td, ...styles.amount }}>
                    {item.price}
                  </td>
                  <td style={{ ...styles.td, ...styles.subtotal }}>
                    {item.subtotal.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot style={{ ...styles.tfoot }}>
              <tr style={{ ...styles.tr }}>
                <td style={{ ...styles.td }} colspan="3">
                  &nbsp;
                </td>
                <td style={{ ...styles.td, ...styles.total }}>Total (£)</td>
                <td style={{ ...styles.td, ...styles.total }}>{total}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}
